import React from "react"
import PropTypes from "prop-types"
import { Switch, Route, Redirect } from "react-router-dom"
import withStyles from "@material-ui/core/styles/withStyles"
import PagesHeader from "components/Header/PagesHeader.jsx"
import Footer from "components/Footer/Footer.jsx"
import AuthRouter from "components/Router/AuthRouter.jsx"
import GlobalSnackbar from "layouts/GlobalSnackbar"
import pagesRoutes from "routes/pages.jsx"
import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx"
import { loginSuccess } from 'actions/auth.js'
import api from 'api/index.js'
import { createBrowserHistory } from 'history'
import { connect } from "react-redux"
import style from "assets/css/style.jsx"

const history = createBrowserHistory();
const styles = require(`../assets/css/style.jsx`).default

class Pages extends React.Component {
  componentWillMount() {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');
    if(token){
      sessionStorage.user_jwt = token
      api.setAuthorizationHeader(token)
      this.props.loginSuccess(token)
      history.push('/')
    }
  }
  render() {
    const { classes, ...rest } = this.props;

    return (
      <div >
        <PagesHeader {...rest} />
        <div className={classes.wrapper} ref="wrapper">
          <div className={classes.fullPage} style={styles.fullPageBg}>
            <Switch>
              {pagesRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return null;
                }
                if (prop.redirect) {
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                }
                if (prop.requireAuth) {
                  return <AuthRouter
                    exact
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                }

                return (
                  <Route
                    exact
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer white/>
            <div className={classes.fullPageBackground}
            />
            <GlobalSnackbar />
          </div>
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(null, { loginSuccess })(withStyles(style, pagesStyle)(Pages));



// WEBPACK FOOTER //
// ./src/layouts/Pages.jsx